import React, { useState } from 'react';
import styles from './orderItemDetail.module.scss';
import cn from 'classnames';

const TabComponent = (props) => {
  const [selected, setSelected] = useState(0);
  const setTab = (index) => {
    setSelected(index);
  };

  const renderContent = () => {
    return (
      <div className={cn('tabs__content h-90 p-2')} style={{ overflow: 'hidden' }}>
        {props.children[selected]}
      </div>
    );
  };

  const renderLabels = () => {
    return props.children.filter((child) => child !== null).map((child, index) => (
      <div key={child.props.label} role="presentation" onClick={() => { setTab(index); }} className={cn(props.children.filter((e) => e !== null).length > 1 ? 'col-6' : 'col-12', 'd-flex justify-content-center align-items-center', index === selected ? 'od-container-card-background background-secondary' : '')}>
        {child.props.label}
      </div>
    ));
  };

  return (
    <div className={cn('tabs h-100 fs-14')}>
      <div className={cn(styles.tabStyle, 'row p-0 col-12 mx-0 h-10')}>
        {renderLabels()}
      </div>
      {renderContent()}
    </div>
  );
};

export default TabComponent;
